module.exports = __webpack_public_path__ + "img/happy_printer.40d9ad0c.png";